import styled from 'styled-components';

export default styled.div`
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--brand-blue);
`;
